'use client';

import { motion } from 'framer-motion';
import { AngleRight } from '../../icons/AngleRight';
import type { RelatedScenariosSectionData } from '../../types';
import { SectionShell, staggerContainer, staggerItem } from '../section-shared';

export function RelatedScenariosSection({ section }: { section: RelatedScenariosSectionData }) {
  return (
    <SectionShell>
      <div className="mb-10 w-full text-center sm:mb-8">
        <h2 className="font-semibold text-[36px] text-white leading-[1.2] sm:text-[28px]">{section.title}</h2>
      </div>
      <motion.div
        className="flex flex-wrap justify-center gap-6 sm:gap-3"
        initial="hidden"
        variants={staggerContainer}
        viewport={{ once: true, margin: '-60px' }}
        whileInView="visible"
      >
        {section.items?.map((item) => (
          <motion.a
            key={item._id}
            className="inline-flex items-center gap-3 rounded-full bg-white/10 px-7 py-4 text-lg text-white transition-colors hover:bg-white/20 active:bg-white/5 sm:px-5 sm:py-3 sm:text-base"
            href={`/tools/${item.slug}`}
            target="_blank"
            variants={staggerItem}
          >
            <span className="whitespace-nowrap leading-6">{item.title}</span>
            <span className="flex size-6 shrink-0 items-center justify-center rounded-full bg-white/10">
              <AngleRight className="size-4 text-white" />
            </span>
          </motion.a>
        ))}
      </motion.div>
    </SectionShell>
  );
}
